module.exports = __webpack_public_path__ + "static/img/banner3.f085b75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner3.jpg
// module id = pwst
// module chunks = 1